// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_PromoCode from "../Ouroboros.Models.Brands.PromoCode/index.js";
import * as Ouroboros_Models_Brands_PromoCodeStatus from "../Ouroboros.Models.Brands.PromoCodeStatus/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ChooseSubscriptionAction = function (x) {
    return x;
};
var tsBridgeChooseSubscriptio = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("ChooseSubscriptionAction")("__brandChooseSubscriptionAction"));
        });
    }
};
var setSelectionLoading = function (env) {
    return function (value) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.selectionLoading))(value);
    };
};
var setPromoLoading = function (env) {
    return function (value) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.promoLoading))(value);
    };
};
var setPromoCodeError = function (env) {
    return function (value) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.promoCodeError))(value);
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runChooseSubscriptionAction = function (v) {
    return v;
};
var promoCodeErrorFromStatus = function (status) {
    var v = Ouroboros_Models_Brands_PromoCodeStatus.unwrap(status);
    if (v === "Valid") {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    if (v === "Expired") {
        return Ouroboros_Services_Clients_Interop_Option.some("This promo code has expired.");
    };
    if (v === "Not Found") {
        return Ouroboros_Services_Clients_Interop_Option.some("The promo code entered is invalid, check your spelling and capitalization.");
    };
    return Ouroboros_Services_Clients_Interop_Option.some("An unknown error occurred while applying the promo code.");
};
var mkChooseSubscriptionAction = ChooseSubscriptionAction;
var maybeToOption = function (value) {
    if (value instanceof Data_Maybe.Nothing) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    if (value instanceof Data_Maybe.Just) {
        return Ouroboros_Services_Clients_Interop_Option.some(value.value0);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.ChooseSubscription (line 183, column 3 - line 185, column 34): " + [ value.constructor.name ]);
};
var toLoadingErrorInput = function (errorValue) {
    return Ouroboros_Models_Core_ErrorHandlers.paymentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: maybeToOption(errorValue.statusCode)
    });
};
var handlePromoValidationSuccess = function (env) {
    return function (promoCode) {
        return function (response) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(setPromoCodeError(env)(promoCodeErrorFromStatus(response.promo_status)));
            })((function () {
                var $34 = Ouroboros_Models_Brands_PromoCodeStatus.unwrap(response.promo_status) === "Valid";
                if ($34) {
                    return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(env.loading.setSuccess), runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.demographicSurveyRoute)(promoCode)) ]));
                };
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
            })());
        };
    };
};
var handlePaymentSuccess = function (env) {
    return function (setupIntentSecret) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(env.loading.setSuccess), runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.paymentSetupRoute)(setupIntentSecret)) ]));
    };
};
var handlePaymentError = function (loading) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var handlePromoValidationError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(setPromoCodeError(env)(promoCodeErrorFromStatus(Ouroboros_Models_Brands_PromoCodeStatus.makePromoCodeStatus("Not Found"))));
        })(handlePaymentError(env.loading)(errorValue));
    };
};
var setupIntentTask = function (env) {
    return function (plan) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePaymentError(env.loading))(handlePaymentSuccess(env))(env.paymentClient.setupIntent(plan));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var handlePackageSelection = function (env) {
    return function (plan) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(setSelectionLoading(env)(false));
            })(setupIntentTask(env)(plan));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(setSelectionLoading(env)(true)));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/choose_subscription_controller.md";
var applyPromoCode = function (env) {
    return function (rawCode) {
        var trimmed = Data_String_Common.trim(rawCode);
        var promoCode = Ouroboros_Models_Brands_PromoCode.makePromoCode(rawCode);
        var $35 = trimmed === "";
        if ($35) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(setPromoCodeError(env)(promoCodeErrorFromStatus(Ouroboros_Models_Brands_PromoCodeStatus.makePromoCodeStatus("Not Found"))));
        };
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePromoValidationError(env))(handlePromoValidationSuccess(env)(promoCode))(env.paymentClient.validatePromoCode(promoCode));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var handlePromoCode = function (env) {
    return function (rawCode) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(setPromoLoading(env)(false));
            })(applyPromoCode(env)(rawCode));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(setPromoLoading(env)(true)));
    };
};
var mkChooseSubscriptionController = function (env) {
    return {
        onPackageSelection: function (plan) {
            return mkChooseSubscriptionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(handlePackageSelection(env)(plan)));
        },
        onApplyPromoCode: function (rawCode) {
            return mkChooseSubscriptionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(handlePromoCode(env)(rawCode)));
        }
    };
};
export {
    ChooseSubscriptionAction,
    mkChooseSubscriptionController,
    runChooseSubscriptionAction,
    documentationPath,
    tsBridgeChooseSubscriptio
};
//# sourceMappingURL=index.js.map
